module.exports = __webpack_public_path__ + "img/horizontal_6_4_3.1a70dba8.png";